<script setup lang="ts">
import { computed } from 'vue'
import type { Confidence } from '@/shared/api/types'

const props = defineProps<{ confidence: Confidence }>()

const LABELS: Record<Confidence, { text: string; dots: number }> = {
    low: { text: 'Low confidence', dots: 1 },
    medium: { text: 'Medium confidence', dots: 2 },
    high: { text: 'High confidence', dots: 3 },
    very_high: { text: 'Very high confidence', dots: 4 },
}

const info = computed(() => LABELS[props.confidence] ?? LABELS.medium)
</script>

<template>
    <span class="confidence badge" :title="`AI confidence: ${info.text}`">
        <span class="dots">
            <i v-for="n in 4" :key="n" :class="{ on: n <= info.dots }"></i>
        </span>
        {{ info.text }}
    </span>
</template>

<style scoped lang="scss">
.confidence {
    .dots {
        display: inline-flex;
        gap: 3px;
        margin-right: 2px;

        i {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: var(--site-border);

            &.on {
                background: var(--site-accent);
            }
        }
    }
}
</style>
